import React, {useContext, useEffect} from 'react';
import {Button, Form, Input} from 'antd';
import './LoginPage.css';
import {useDispatch} from "react-redux";
// import { ApiContext } from "../../ApiContext";
import axios from "axios";
import {ApiContext} from "../../../ApiContext";
import AmfyLogo from "../../../layout/AmfyLogo";

const LoginPage = () => {
    const dispatch = useDispatch()
    const {txt, getFromStore, afterLogin} = useContext(ApiContext);
    // const [login, setLogin] = useState('q@q.q');
    // const [password, setPassword] = useState('12345');


    // const getTheme = async () => {
    //     try {
    //         let theme = await getFromStore('theme');
    //         if (isNotBlank(theme) || theme != undefined) {
    //             dispatch(setTheme(theme));
    //         }
    //     } catch (error) {
    //         console.log('error = ', error);
    //     }
    // }

    // const getAuthFromStore = async () => {
    //     try {
    //         const accessToken = await getFromStore('access_token');
    //         const refreshToken = await getFromStore('refresh_token');
    //         const accessTokenExpDate = await getFromStore('accessTokenExpDate');
    //         const refreshTokenExpDate = await getFromStore('refreshTokenExpDate');
    //         const currentUserRole = await getFromStore('currentUserRole'); //
    //
    //         if (isNotBlank(accessToken) && isNotBlank(refreshToken)) {
    //
    //             // let home = getHomeScreenFromRole(currentUserRole);
    //             if (isNotBlank(currentUserRole)) {
    //                 dispatch(setUserRole(currentUserRole));
    //             }
    //
    //             dispatch(
    //                 setAuth({
    //                     accessToken: accessToken,
    //                     refreshToken: refreshToken,
    //                     accessTokenExpDate: accessTokenExpDate,
    //                     refreshTokenExpDate: refreshTokenExpDate,
    //                 })
    //             );
    //             // console.log('from: LoginPage -> getAuthFromStore():', {currentUserRole}, {home} )
    //             // todo посмотреть что это за параша и зачем тут ресетить
    //             // navigation.reset({
    //             //     index: 0,
    //             //     routes: [{ name: home }],
    //             //     // routes: [{ name: 'HomePage' }],
    //             // });
    //             // // navigation.replace('HomePage');
    //             // navigation.navigate('HomePage');
    //         }
    //     } catch (error) {
    //         console.error('Failed to get auth data', error);
    //     }
    // };

    useEffect(() => {
        // getAuthFromStore();
    }, []);

    const doLogin = (values) => {
        // const body = {login: login, password: password};
        axios.post('/user/login', values)
            .then((genericResponse) => {
                console.log(genericResponse);
                afterLogin(genericResponse);
            }).catch(error => {
            console.log(error);
        });
    };
    return (
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <AmfyLogo/>
            <Form
                name="basic"
                onFinish={doLogin}
                autoComplete="off"
                style={{alignItems:'center', justifyContent:'center'}}
            >
                <Form.Item
                    name="login"
                    rules={[
                        {
                            required: true,
                            message: txt("register.fieldShouldBeNotBlank"),
                        },
                    ]}
                >
                    <Input
                        style={{maxWidth:450}}
                        placeholder={txt("register.loginText")}
                        // prefix={<UserOutlined className="site-form-item-icon" />}
                        // value={login}
                        // onChange={(event) => setLogin(event.target.value)}
                        autoComplete="new-password"
                    />
                </Form.Item>
                <Form.Item
                    name="password"
                    rules={[
                        {
                            required: true,
                            message: txt("register.fieldShouldBeNotBlank"),
                        },
                    ]}
                >
                    <Input.Password
                        style={{maxWidth:450}}
                        placeholder={txt("register.password")}
                        // value={password}
                        // onChange={(event) => setPassword(event.target.value)}
                        autoComplete="new-password"
                    />
                </Form.Item>
                <Form.Item>
                    <Button style={{maxWidth:450, display: 'block', margin: '0 auto'}} type="primary" htmlType="submit">{txt("register.loginButton")}</Button>
                </Form.Item>
            </Form>
        </div>
    );
}

export default LoginPage;
